import React from 'react'
import type {AccessibleLocation,AccessContext} from '../../../types/access'
import {SupervisorOperationsPanel} from '../supervisor/SupervisorOperationsPanel'

interface SupervisorDashboardPanelProps {
  accessContext: AccessContext | null
  accessibleLocations: AccessibleLocation[]
}

export const SupervisorDashboardPanel:React.FC<SupervisorDashboardPanelProps>=({accessContext})=><SupervisorOperationsPanel accessContext={accessContext}/>
